import { useRouter } from "next/router";
import React from "react";

import { ROUTES } from "shared/constants";
import { useCustomerName } from "shared/hooks/userHeader";

import Img from "@components/FileServer/Img";
import FormattedMessage from "@components/UI/FormattedMessage";
import SetCurrencyMobile from "@components/UI/Header/SetCurrencyMobile";
import SetLanguageMobile from "@components/UI/Header/SetLanguageMobile";
import Link from "@components/UI/Link";

import { useHeaderMenu } from "./Menu";

export default function HeaderMobileMenu({
  toggleMobileMenu,
  showMobileChangeLanguage,
  showMobileChangeCurrency,
  showMobileMenu,
  toggleMobileChangeLanguage,
  toggleMobileChangeCurrency,
  isLoggedIn,
  logout,
  isCbtEnabled,
}) {
  const router = useRouter();
  const menuItems = useHeaderMenu();
  const customerName = useCustomerName();
  const currentPageUrl = Array.isArray(router.query.url)
    ? router.query.url[0]
    : router.query.url;

  return (
    <>
      <div
        className={`header-mobile-menu ${
          showMobileMenu ? "header-mobile-menu-show" : ""
        }`}
      >
        {!showMobileChangeLanguage && !showMobileChangeCurrency && isLoggedIn && (
          <Link
            href={{
              pathname: ROUTES.PROFILE,
              query: {
                ...(router.query.lang ? { lang: router.query.lang } : {}),
                ...(router.query?.typeSearch
                  ? { typeSearch: router.query.typeSearch }
                  : {}),
                ...(router.query.currency
                  ? { currency: router.query.currency }
                  : {}),
              },
            }}
          >
            <a
              role="link"
              className="header-mobile-menu-link header-mobile-menu-user"
              id="header-mobile-user"
              aria-current={
                router.route === ROUTES.PROFILE ? "page" : undefined
              }
              onClick={toggleMobileMenu}
            >
              <Img
                src="/static/images/ico-signin.svg"
                className="header-mobile-menu-user-icon"
                alt=""
              />
              <span className="header-mobile-menu-user-text">
                <strong className="header-mobile-menu-user-name">
                  {customerName}
                </strong>
                <span className="header-mobile-menu-user-label">
                  <FormattedMessage id="Profile.myProfile" />
                </span>
              </span>
            </a>
          </Link>
        )}
        {!showMobileChangeLanguage && !showMobileChangeCurrency && isLoggedIn && (
          <Link
            href={{
              pathname: "/reservations",
              query: router.query.lang ? { lang: router.query.lang } : {},
            }}
          >
            <a
              role="link"
              className="header-mobile-menu-link"
              aria-current={
                router.route === "/reservations" ? "page" : undefined
              }
              onClick={toggleMobileMenu}
            >
              <FormattedMessage id="HeaderLogoStripe.reservation-button" />{" "}
            </a>
          </Link>
        )}
        {!showMobileChangeLanguage &&
          !showMobileChangeCurrency &&
          menuItems.map((menuItem, index) => {
            if (menuItem.alternativeUrl) {
              return (
                <a
                  key={menuItem.url || index}
                  href={menuItem.alternativeUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="header-mobile-menu-link"
                  onClick={toggleMobileMenu}
                >
                  {menuItem.label}
                </a>
              );
            }
            return (
              <Link
                href={{
                  pathname: "/page",
                  query: { url: menuItem.url },
                }}
                as={`/page/${menuItem.url}`}
                key={menuItem.url}
              >
                <a
                  role="link"
                  className="header-mobile-menu-link"
                  aria-current={
                    router.route === "/page" && currentPageUrl === menuItem.url
                      ? "page"
                      : undefined
                  }
                  onClick={toggleMobileMenu}
                >
                  {menuItem.label}
                </a>
              </Link>
            );
          })}
        {!showMobileChangeLanguage &&
          !showMobileChangeCurrency &&
          !isLoggedIn &&
          router.route !== "/login" && (
            <Link
              href={{
                pathname: "/login",
                query: {
                  ...(router.query?.isLoginRequired && {
                    isLoginRequired: router.query.isLoginRequired,
                  }),
                  redirectAfterLogin: router.asPath,
                },
              }}
            >
              <a
                role="link"
                className="header-mobile-menu-link"
                onClick={toggleMobileMenu}
              >
                <FormattedMessage id="Screen.Login.title" />
              </a>
            </Link>
          )}
        {showMobileChangeLanguage && <SetLanguageMobile />}
        {showMobileChangeCurrency && <SetCurrencyMobile />}
        {isCbtEnabled && (
          <a
            className="header-mobile-menu-link"
            target="_blank"
            rel="noopener noreferrer"
            href="https://www.cee-systems.com/privacypolicy"
            onClick={toggleMobileMenu}
          >
            <FormattedMessage id="HeaderLogoStripe.privacyPolicy" />
          </a>
        )}
        {!showMobileChangeLanguage && !showMobileChangeCurrency && (
          <>
            <button
              type="button"
              onClick={toggleMobileChangeLanguage}
              className="header-mobile-menu-link"
            >
              <FormattedMessage id="HeaderLogoStripe.changeLanguage" />
            </button>
            <button
              type="button"
              onClick={toggleMobileChangeCurrency}
              className="header-mobile-menu-link"
            >
              <FormattedMessage id="HeaderLogoStripe.changeCurrency" />
            </button>
          </>
        )}
        {showMobileChangeLanguage && !showMobileChangeCurrency && (
          <button
            type="button"
            onClick={toggleMobileChangeLanguage}
            className="header-mobile-menu-link"
          >
            <FormattedMessage id="HeaderLogoStripe.keepLanguage" />
          </button>
        )}
        {!showMobileChangeLanguage && showMobileChangeCurrency && (
          <button
            type="button"
            onClick={toggleMobileChangeCurrency}
            className="header-mobile-menu-link"
          >
            <FormattedMessage id="HeaderLogoStripe.keepCurrency" />
          </button>
        )}{" "}
        {!showMobileChangeLanguage && !showMobileChangeCurrency && isLoggedIn && (
          <button
            type="button"
            onClick={() => {
              toggleMobileMenu();
              logout();
            }}
            className="header-mobile-menu-link underline"
            id="header-mobile-logout"
          >
            <FormattedMessage id="Profile.logout" />
          </button>
        )}
      </div>
      {showMobileMenu && <div className="header-mobile-menu-background" />}
    </>
  );
}
